import { getPricingOfAccountSmsCampaign } from "../types/account_campaign_pricing_sms_types";

const initState = {
  data: [],
  loading: false,
  error: null,
  cellLoading: null,
};

export default function accountCampaignPricingSmsReducer(state = initState, action = {}) {
  switch (action.type) {
    case getPricingOfAccountSmsCampaign.GET_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case getPricingOfAccountSmsCampaign.GET_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        error: null,
      };
    case getPricingOfAccountSmsCampaign.GET_PRICING_OF_ACCOUNT_SMS_CAMPAIGN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
